var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('welcome-conference-banner',{staticClass:"py-8",attrs:{"background-color":"#FAFAFA"}}),_c('welcome-message',{attrs:{"custom-background-style":"background: linear-gradient(151.84deg, #596687 10.82%, #4B5671 98.95%);"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }